import React, { FC } from 'react';
import { Props } from './types';
import { Container, ContentLoader } from './styles';

const Loader: FC<Props> = ({ opacity = 1 }) => {
  return (
    <Container>
      <ContentLoader
        viewBox="0 0 400 30"
        backgroundColor="#f1f1f1"
        $opacity={opacity}
      >
        <rect x="6" y="9" rx="3" ry="3" width="53" height="6" />
        <rect x="6" y="19" rx="3" ry="3" width="20" height="6" />
        <rect x="80" y="9" rx="3" ry="3" width="40" height="6" />
        <rect x="80" y="19" rx="3" ry="3" width="150" height="6" />
        <circle cx="276" cy="16" r="9" />
        <rect x="290" y="14" rx="3" ry="3" width="40" height="6" />
        <rect x="357" y="14" rx="3" ry="3" width="38" height="6" />
      </ContentLoader>
    </Container>
  );
};

export default Loader;

// TODO: TFR-44 move to Loaders group
